<template>
    <div>
        <v-card>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Paperwork Analytics
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
        
        <v-container grid-list-xs>
            <v-form ref="form" lazy-validation class="mb-2">
                <v-row justify="center" style="margin-top: 10px;">
                    <v-col cols="2">
                        <v-text-field label="Start Date" id="StartDate" :value="StartDate"
                            :placeholder="$store.state.placeholder" v-mask="$store.state.mask"
                            :rules="$store.state.dateRules" dense hide-details required></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field label="End Date" id="EndDate" :value="EndDate"
                            :placeholder="$store.state.placeholder" v-mask="$store.state.mask"
                            :rules="$store.state.dateRules" dense hide-details required></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="primary" small class="my-auto ml-2" @click="getCurrentStatusOrders">Search</v-btn>
                    </v-col>
                    <!-- <v-col cols="2">
                        <v-chip label>Total Shifts : <strong>{{ ShiftDetails.length }}</strong></v-chip>
                    </v-col> -->
                </v-row>
            </v-form>
        </v-container>
        <v-container fluid v-if="chargeView">
            <v-row>
                <v-col cols="3" >
                    <div style="height: 100vh;">
                        <v-toolbar dense dark flat height="35" color="secondary" class="white--text">
                            <v-btn v-if="viewNotReviewed" icon color="#fff">
                                <v-icon>
                                    mdi-refresh
                                </v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                Orders To Be Reviewed
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="viewNotReviewed" icon color="#fff" @click="openPaperworkAnalyticsPanel">
                                <v-icon>
                                    mdi-file-find
                                </v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card v-if="viewNotReviewed">
                            <v-card-title>
                                <v-text-field dense v-model="searchOrdersNotReviewed" append-icon="mdi-magnify"
                                    label="Search" single-line hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table dense disable-sort :headers="headers" :items="itemsOrdersNotReviewed"
                                :search="searchOrdersNotReviewed">
                                <template v-slot:item.actions="{ item }">
                                    <!-- <v-icon color="success" class="mr-2"
                                        @click="sendToVerifiedOrders(item)">mdi-check-decagram-outline</v-icon> -->
                                    <v-icon color="primary" class="mr-2"
                                        @click="openOrderDataViewer(item)">mdi-eye-outline</v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                        <div v-else>
                            <div class="sk-circle">
                                <div class="sk-circle1 sk-child"></div>
                                <div class="sk-circle2 sk-child"></div>
                                <div class="sk-circle3 sk-child"></div>
                                <div class="sk-circle4 sk-child"></div>
                                <div class="sk-circle5 sk-child"></div>
                                <div class="sk-circle6 sk-child"></div>
                                <div class="sk-circle7 sk-child"></div>
                                <div class="sk-circle8 sk-child"></div>
                                <div class="sk-circle9 sk-child"></div>
                                <div class="sk-circle10 sk-child"></div>
                                <div class="sk-circle11 sk-child"></div>
                                <div class="sk-circle12 sk-child"></div>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="3">
                    <div style="height: 100vh;">
                        <v-toolbar dense dark flat height="35" color="success" class="white--text">
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                Orders Reviewed And Verified
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card v-if="viewVerified">
                            <v-card-title>
                                <v-text-field dense v-model="searchOrdersReviewedAndVerified" append-icon="mdi-magnify"
                                    label="Search" single-line hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table dense disable-sort :headers="headers" :items="itemsOrdersReviewedAndVerified"
                                :search="searchOrdersReviewedAndVerified">
                                <template v-slot:item.actions="{ item }">
                                    <v-icon color="error" class="mr-2"
                                        @click="sendToNotVerifiedOrders(item)">mdi-alert-decagram-outline</v-icon>
                                    <v-icon color="primary" class="mr-2"
                                        @click="openOrderDataViewer(item)">mdi-eye-outline</v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                        <div v-else>
                            <div class="sk-circle">
                                <div class="sk-circle1 sk-child"></div>
                                <div class="sk-circle2 sk-child"></div>
                                <div class="sk-circle3 sk-child"></div>
                                <div class="sk-circle4 sk-child"></div>
                                <div class="sk-circle5 sk-child"></div>
                                <div class="sk-circle6 sk-child"></div>
                                <div class="sk-circle7 sk-child"></div>
                                <div class="sk-circle8 sk-child"></div>
                                <div class="sk-circle9 sk-child"></div>
                                <div class="sk-circle10 sk-child"></div>
                                <div class="sk-circle11 sk-child"></div>
                                <div class="sk-circle12 sk-child"></div>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="3">
                    <div style="height: 100vh;">
                        <v-toolbar dense dark flat height="35" color="#e6b800" class="white--text">
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                BOL Cleared 
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            
                        </v-toolbar>
                        <v-card v-if="viewBOLCleared">
                            <v-card-title>
                                <v-text-field dense v-model="searchOrdersBOLCleared" append-icon="mdi-magnify"
                                    label="Search" single-line hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table dense disable-sort :headers="headers" :items="itemsOrdersReviewedBOLCleared"
                                :search="searchOrdersBOLCleared">
                                <template v-slot:item.actions="{ item }">
                                    <v-icon color="success" class="mr-2"
                                        @click="sendToVerifiedOrders(item)">mdi-check-decagram-outline</v-icon>
                                    <v-icon color="primary" class="mr-2"
                                        @click="openOrderDataViewer(item)">mdi-eye-outline</v-icon>
                                     <v-icon color="error" class="mr-2"
                                        @click="sendToNotVerifiedOrders(item)">mdi-alert-decagram-outline</v-icon> 
                                </template>
                            </v-data-table>
                        </v-card>
                        <div v-else>
                            <div class="sk-circle">
                                <div class="sk-circle1 sk-child"></div>
                                <div class="sk-circle2 sk-child"></div>
                                <div class="sk-circle3 sk-child"></div>
                                <div class="sk-circle4 sk-child"></div>
                                <div class="sk-circle5 sk-child"></div>
                                <div class="sk-circle6 sk-child"></div>
                                <div class="sk-circle7 sk-child"></div>
                                <div class="sk-circle8 sk-child"></div>
                                <div class="sk-circle9 sk-child"></div>
                                <div class="sk-circle10 sk-child"></div>
                                <div class="sk-circle11 sk-child"></div>
                                <div class="sk-circle12 sk-child"></div>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="3">
                    <div style="height: 100vh;">
                        <v-toolbar dense dark flat height="35" color="error" class="white--text">
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                Orders Reviewed But Not Verified
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card v-if="viewNotVerified">
                            <v-card-title>
                                <v-text-field dense v-model="searchOrdersReviewedButNotVerified" append-icon="mdi-magnify"
                                    label="Search" single-line hide-details></v-text-field>
                            </v-card-title>
                            <v-data-table dense disable-sort :headers="headers" :items="itemsOrdersReviewedButNotVerified"
                                :search="searchOrdersReviewedButNotVerified">
                                <template v-slot:item.actions="{ item }">
                                    <v-icon color="success" class="mr-2"
                                        @click="sendToVerifiedOrders(item)">mdi-check-decagram-outline</v-icon>
                                    <v-icon color="primary" class="mr-2"
                                        @click="openOrderDataViewer(item)">mdi-eye-outline</v-icon>
                                </template>
                            </v-data-table>
                        </v-card>
                        <div v-else>
                            <div class="sk-circle">
                                <div class="sk-circle1 sk-child"></div>
                                <div class="sk-circle2 sk-child"></div>
                                <div class="sk-circle3 sk-child"></div>
                                <div class="sk-circle4 sk-child"></div>
                                <div class="sk-circle5 sk-child"></div>
                                <div class="sk-circle6 sk-child"></div>
                                <div class="sk-circle7 sk-child"></div>
                                <div class="sk-circle8 sk-child"></div>
                                <div class="sk-circle9 sk-child"></div>
                                <div class="sk-circle10 sk-child"></div>
                                <div class="sk-circle11 sk-child"></div>
                                <div class="sk-circle12 sk-child"></div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <OrderDataViewer :OrderToCheck="OrderToCheck"></OrderDataViewer>

        <PaperworkAnalyticsPanel :OrdersNotReviewed="itemsOrdersNotReviewed" :FromEleosCheck="false"
            @close="onPaperworkAnalyticsPanelClose"></PaperworkAnalyticsPanel>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import OrderDataViewer from './OrderDataViewer.vue';
import PaperworkAnalyticsPanel from './PaperworkAnalyticsPanel.vue';

export default {
    props: [],
    components: {
        OrderDataViewer,
        PaperworkAnalyticsPanel
    },
    directives: { mask },
    data: function () {
        return {
            items:[],
            chargeView: false,
            StartDate: '',
            EndDate: '',
            OrderID: null,
            Shifts: null,
            currentOrdersNotReviewed: [],
            currentOrdersReviewedAndVerified: [],
            currentOrdersReviewedButNotVerified: [],
            currentOrdersReviewedBOLCleared:[],
            currentOrderToCheck: [],
            searchOrdersNotReviewed: '',
            searchOrdersReviewedAndVerified: '',
            searchOrdersReviewedButNotVerified: '',
            searchOrdersBOLCleared: '',
            headers: 
            [
                {
                    text: 'Truck',
                    align: 'center',
                    value: 'Truck',
                },
                {
                    text: 'OrderStatus',
                    align: 'center',
                    value: 'OrderStatus',
                },
                {
                    text: 'OrderID',
                    align: 'center',
                    value: 'OrderID',
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'actions',
                },
            ],
            ShiftDetails:null,
            itemsOrdersNotReviewed: [],
            itemsOrdersReviewedAndVerified: [],
            itemsOrdersReviewedButNotVerified: [],
            itemsOrdersReviewedBOLCleared:[],
            viewNotReviewed: false,
            viewBOLCleared:false,
            viewNotVerified: false,
            viewVerified: false,
            OrderToCheck:null,
        }
    },
    mounted() {
        // this.loadCurrentOrdersNotReviewed();
        // this.loadCurrentOrdersReviewedAndVerified();
        // this.loadCurrentOrdersReviewedButNotVerified();
        // this.getCurrentOrdersReviewedButBOLCleared();
    },
    methods: {
        getCurrentStatusOrders: function () {
            var str = this.$store;
            str.state.isLoading = true;
            this.chargeView= true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
            };
            axios
                .post('paperwork-analytics/current-orders', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.items = response.data;
                    var Shifts = await response.data.map(x => {
                        return x.ShiftDetail;
                    });
                    this.ShiftDetails = this.eliminarDuplicados(Shifts);
                    
                    console.log(this.ShiftDetails.length);
                    this.itemsOrdersNotReviewed = response.data.filter(x => {
                        return x.BolCheckStatusID == 0;
                    });
                    this.viewNotReviewed = true;
                    this.itemsOrdersReviewedAndVerified = response.data.filter(x => {
                        return x.BolCheckStatusID == 1;
                    });
                    this.viewNotVerified =true;
                    this.itemsOrdersReviewedBOLCleared = response.data.filter(x => {
                        return x.BolCheckStatusID == 2;
                    });
                    this.viewBOLCleared =true;  
                    this.itemsOrdersReviewedButNotVerified = response.data.filter(x => {
                        return x.BolCheckStatusID == 3;
                    });                  
                    this.viewVerified =true;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        openOrderDataViewer: function (itm) {
            console.log(itm);
            this.OrderToCheck = itm;
            this.$store.state.paperworkAnalytics.showOrderDataViewer = true;
        },
        openPaperworkAnalyticsPanel: function () {
            this.$store.state.paperworkAnalytics.showPaperworkAnalyticsPanel = true;
        },
        sendToVerifiedOrders: async function (itm) {
            var str = this.$store;
            console.log("sendToVerifiedOrders");
            var parms = {
                BolCheckStatusID: 1
            }
            this.$store.state.isLoading = true;
            await axios
                .put('order/' + itm.OrderID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    itm.BolCheckStatusID = 1;
                    this.regrouping();
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        regrouping: function (){
                    this.itemsOrdersNotReviewed = this.items.filter(x => {
                        return x.BolCheckStatusID == 0;
                    });
                    this.viewNotReviewed = true;
                    this.itemsOrdersReviewedAndVerified = this.items.filter(x => {
                        return x.BolCheckStatusID == 1;
                    });
                    this.viewNotVerified =true;
                    this.itemsOrdersReviewedBOLCleared = this.items.filter(x => {
                        return x.BolCheckStatusID == 2;
                    });
                    this.viewBOLCleared =true;  
                    this.itemsOrdersReviewedButNotVerified = this.items.filter(x => {
                        return x.BolCheckStatusID == 3;
                    });                
        },
        sendToNotVerifiedOrders: async function (itm) {
            var str = this.$store;
            console.log("sendToNotVerifiedOrders");
            console.log(itm);
            var parms = {
                BolCheckStatusID: 3
            }
            this.$store.state.isLoading = true;
            await axios
                .put('order/' + itm.OrderID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    
                    itm.BolCheckStatusID = 3;
                    this.regrouping();
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        onPaperworkAnalyticsPanelClose: function () {
            // this.loadCurrentOrdersNotReviewed();
            // this.loadCurrentOrdersReviewedAndVerified();
            // this.loadCurrentOrdersReviewedButNotVerified();
            // this.getCurrentOrdersReviewedButBOLCleared();
            this.getCurrentStatusOrders();
        },
        eliminarDuplicados: function (arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
    },
};
</script>

<style>
.sk-circle {
    margin: 100px auto;
    width: 40px;
    height: 40px;
    position: relative;
}

.sk-circle .sk-child {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

.sk-circle .sk-child:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
    animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}

.sk-circle .sk-circle2 {
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
}

.sk-circle .sk-circle3 {
    -webkit-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    transform: rotate(60deg);
}

.sk-circle .sk-circle4 {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}

.sk-circle .sk-circle5 {
    -webkit-transform: rotate(120deg);
    -ms-transform: rotate(120deg);
    transform: rotate(120deg);
}

.sk-circle .sk-circle6 {
    -webkit-transform: rotate(150deg);
    -ms-transform: rotate(150deg);
    transform: rotate(150deg);
}

.sk-circle .sk-circle7 {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}

.sk-circle .sk-circle8 {
    -webkit-transform: rotate(210deg);
    -ms-transform: rotate(210deg);
    transform: rotate(210deg);
}

.sk-circle .sk-circle9 {
    -webkit-transform: rotate(240deg);
    -ms-transform: rotate(240deg);
    transform: rotate(240deg);
}

.sk-circle .sk-circle10 {
    -webkit-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
}

.sk-circle .sk-circle11 {
    -webkit-transform: rotate(300deg);
    -ms-transform: rotate(300deg);
    transform: rotate(300deg);
}

.sk-circle .sk-circle12 {
    -webkit-transform: rotate(330deg);
    -ms-transform: rotate(330deg);
    transform: rotate(330deg);
}

.sk-circle .sk-circle2:before {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.sk-circle .sk-circle3:before {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
}

.sk-circle .sk-circle4:before {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.sk-circle .sk-circle5:before {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

.sk-circle .sk-circle6:before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}

.sk-circle .sk-circle7:before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}

.sk-circle .sk-circle8:before {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
}

.sk-circle .sk-circle9:before {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}

.sk-circle .sk-circle10:before {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
}

.sk-circle .sk-circle11:before {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
}

.sk-circle .sk-circle12:before {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleBounceDelay {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes sk-circleBounceDelay {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>